export const UPDATE_QUERY_GROUP_ORDER_NAME = "update_query_group_order";
export const UPDATE_QUERY_GROUP_ORDER_DESC =
  "Update the order of Search Analytics query groups by ID list.";
